import { render, staticRenderFns } from "./SalutationInput.vue?vue&type=template&id=360d5e7b&scoped=true"
import script from "./SalutationInput.vue?vue&type=script&lang=ts"
export * from "./SalutationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d5e7b",
  null
  
)

export default component.exports